import React, { Component } from 'react'
import { Layout } from '../../widgets'
import * as routes from '../../routes'
import { AdminHashtagCell } from '../components'
import { NavigationTab, PaginatedList } from '../../components'

class AdminHashtags extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tab: 'Trending',
    }
  }

  render = () => {
    const tabs = {
      'Trending': <PaginatedList
        key={'trending'}
        loadUrl={routes.adminHashtagTrendingUrl}
        loadParams={{}}
        cell={AdminHashtagCell}
        cellItemPropName={'hashtag'}
        datePicker={false}
        featureActionUpdateBehavior={'filter'}
      />,
    }

    return (
      <div className='body-container'>
        <Layout>
          <Layout.Header>Hashtags</Layout.Header>
          <div className='moderator-content'>

            <div className='navigation-tabs'>
              {Object.keys(tabs).map((tab, i) =>
                <NavigationTab
                  key={i}
                  text={tab}
                  isActive={this.state.tab === tab}
                  onClick={() => {
                    if (this.state.tab !== tab) {
                      this.setState({ tab: tab })
                    }
                  }}
                />
              )}
            </div>

            {tabs[this.state.tab]}

          </div>
        </Layout>
      </div>
    )
  }
}

export default AdminHashtags
